<template>
    <div class="date_box">
        <!-- 左侧文案：周视图下是选择的当前周，月视图下是当前年月，年视图下是选择的年份 -->
        <div class="Disp_AC" style="flex: 1;overflow: hidden">
            <span class="fs32 AkrobatM Main_Color">{{date}}</span>
            <el-tooltip
                class="date_text ml30"
                effect="dark"
                :content="text"
                placement="top"
                popper-class="date_text_tooltip"
            >
                <span class="fs16 Text_Over" style="line-height: 22px;">{{text}}</span>
            </el-tooltip>
        </div>
        <div class="Disp_AC">
            <!-- 周月年tab切换 -->
            <div class="date_type" v-if="showDateType">
                <el-radio-group v-model="type" size="small" @change="$emit('change', type)">
                    <el-radio-button label="today">{{$t('schedule.今天')}}</el-radio-button>
                    <el-radio-button label="week">{{$t('schedule.周')}}</el-radio-button>
                    <el-radio-button label="month">{{$t('schedule.月')}}</el-radio-button>
                    <el-radio-button label="year">{{$t('schedule.年')}}</el-radio-button>
                </el-radio-group>
            </div>
            <!-- 左右切换 -->
            <cl-svg-icon
                @click.native="preDate"
                class="ml8 mr8 tu_arrow"
                width="34"
                icon-class="tu_arrow_left"
            ></cl-svg-icon>
            <cl-svg-icon
                @click.native="nextDate"
                class="tu_arrow"
                width="34"
                icon-class="tu_arrow_right"
            ></cl-svg-icon>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cl-card-date',
    model: {
        prop: 'value',
        event: 'change'
    },
    data () {
        return {
            type: this.value || 'week',
        };
    },

    props: {
        value: {},
        date: {},
        text: {},
        showDateType: {
            type: Boolean,
            default: true,
        }
    },

    computed: {
        // 是否是今天tab
        isToday () {
            return this.type === 'today';
        },
    },

    methods: {
        // 上一个日期
        preDate () {
            if (this.isToday) this.type = 'week';
            this.$emit('changeDate', 'previous');
        },
        // 下一个日期
        nextDate () {
            if (this.isToday) this.type = 'week';
            this.$emit('changeDate', 'next');
        },
    }
}
</script>
<style>
.date_text_tooltip {
    max-width: 426px;
    line-height: 17px;
    font-size: 12px;
}
</style>
<style lang='scss' scoped>
.date_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .date_type {
        background: #f3f5f9;
        border-radius: $base-border-radius-mini;
        padding: 2px 0;
    }
}

.tu_arrow.svg-icon {
    background-color: #f3f5f9;
    border-radius: 6px;
    color: #b7b7bf;
    &:hover {
        background-color: #3663e1;
        color: #ffffff;
    }
}
.radio {
    width: fit-content;
    padding: 5px;
    box-sizing: border-box;
    background: rgba(251, 253, 255, 0.8);
    border: 1px solid #e9edf3;
    border-radius: 6px;
}

/deep/.el-radio-button {
    min-width: 78px;
    margin-right: 5px;
    text-align: center;
    &:last-child {
        margin-right: 0;
    }
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-radius: 4px;
    box-shadow: 0px 6px 8px rgba(54, 99, 225, 0.3) !important;
}
/deep/.el-radio-button__inner {
    background-color: transparent;
    border-radius: 4px;
    border: none !important;
    color: #81818a;
    font-size: 14px;
    display: inline-block;
    width: 100%;
    padding: 10px 15px;
}
</style>
